import * as Yup from 'yup'

const scrapingIssueReportSchema = Yup.object().shape({
  dateRange: Yup.array().required('Date range is required'),
})

export default scrapingIssueReportSchema
